export default "__VITE_ASSET__BqxNgkyq__"